/**
 * Logging helpers, mirroring process-runner's `logging.service`.
 *
 * Only `logApiError` hits the server (via `api/Logging`). The console helpers
 * are console-only and exist for parity / searchable call sites — they are not
 * server telemetry.
 */

import { loggingErrorApi, JSError } from '@api/Logging/logging'

export { JSError }

/** Server log. Pass only `JSError` enum values, never free-form strings. */
export async function logApiError(error: JSError) {
  return loggingErrorApi(error)
}

export function logError(error: unknown, data?: unknown) {
  console.error(error, data)
}

export function logWarn(warning: string, data?: unknown) {
  console.warn(warning, data)
}

export function logInfo(info: string, data?: unknown) {
  console.info(info, data)
}

export function logTrace(info: string) {
  console.trace(info)
}
